<template>
<div></div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Logout',
  beforeRouteEnter(to, from, next) {
    if (to.params.user) {
      const { user } = to.params;
      next((vm) => {
        vm.loginSuccess(user);
        vm.$router.push('/');
      });
    } else {
      next();
    }
  },
  methods: {
    ...mapMutations([
      'logout',
      'loginSuccess'
    ])
  },
  created() {
    this.logout();
    this.$router.push('/');
  }
};
</script>
